import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/styles/main.css';
import '../src/styles/custom/custom.css';
import * as serviceWorker from './serviceWorker';
import routes from '../src/config/routes';
const root = createRoot(document.getElementById('root'));
root.render(routes);
serviceWorker.unregister();